import { createContext } from '@nucleus/react-components';
import React from 'react';

interface PostHubController {
  engineId: string;
  basePath: string;
}

const [PostHubProvider, usePostHub] = createContext<PostHubController>({
  name: 'PostHub',
});

export { usePostHub };

interface PostHubControllerProps extends useControllerProps {
  children: React.ReactNode;
}
export const PostHubController = ({ children, ...props }: PostHubControllerProps): JSX.Element => {
  return <PostHubProvider value={useController(props)}>{children}</PostHubProvider>;
};

interface useControllerProps {
  engineId: string;
  basePath: string;
}
const useController = (props: useControllerProps): PostHubController => {
  return {
    engineId: props.engineId,
    basePath: props.basePath,
  };
};
